module.exports = __webpack_public_path__ + "img/cityHover.0c478125.png";